module.exports = __webpack_public_path__ + "static/media/icon_close.1bfc3d73.svg";